import { selectInternalWidgets, updateWidgetPropertyByPath, useAppDispatch, useAppStore } from '../store';
import { calculateFunctions, getFunctionsObject } from '../foundation';
import { IUpdateWidgetPropertyByPath, TCommonData, TWidget } from '@libs/types';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

export const useFunction = (widget?: TWidget<TCommonData>) => {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const { internalIds, functionObjects } = getFunctionsObject(widget?.functions);

    useEffect(() => {
        if (!widget || internalIds.size === 0) return;

        const dispatchPropertyUpdate = (payload: IUpdateWidgetPropertyByPath) => {
            dispatch(updateWidgetPropertyByPath(payload));
        };

        let lastInternalWidgets = selectInternalWidgets(store.getState(), internalIds);
        calculateFunctions(widget, functionObjects, lastInternalWidgets, dispatchPropertyUpdate);

        return store.subscribe(() => {
            const next = selectInternalWidgets(store.getState(), internalIds);
            if (shallowEqual(lastInternalWidgets, next)) return;
            lastInternalWidgets = next;
            calculateFunctions(widget, functionObjects, next, dispatchPropertyUpdate);
        });
    }, [dispatch, functionObjects, internalIds, store, widget]);
};
